mutation ApprovalHistoryActions($input: ApprovalHistoryActionsInput!) {
  approvalHistoryActions(input: $input) {
    approvalActionResults {
      entityApprovalBranchId
      approvalHistory {
        id
        additionalApprovalInformation
        approvalHistoryPhaseType {
          phaseName
        }
        approvalHistoryApprover {
          requesterDate
          requesterName
          approvedDate
          approvers
          rejectedDate
          rejectors
          amendedDate
          amendedByName
        }
        isHistory
        entityId
        entityApprovalBranchId
        entityApprovalBranchRowTimestamp
        displayEntityApprovalId
        requestedDate
        requiredDate
        isApproved
        approvedDate
        isRejected
        rejectedDate
        revokedDate
        isApprovalTreeViewerAllowed
        isApproverAddingAllowed
        _pendingApprovers
        userEntityApp {
          linkType
          linkTitle
        }
        approvalHistorySignaturesByEntityApprovalId(orderBy: SORT_ORDER_ASC) {
          nodes {
            id
            additionalInformation
            digitalSignature
            actionDate
            isApproved
            isRejected
            isRequested
            userName
            entityDocumentId
            userSignatureDocument {
              id
              _downloadLink
              fileIndexInformation
              fileReference
              iconType
            }
          }
        }
        requesterName
        approvalPersona
        approvalType {
          approvalType
          id
          _isPaymentTrackingStandalone
          _isPurchaseOrderSystem
          _isTravelAuthSystem
          _isSigningStandalone
        }
        statusType {
          approvalState
          statusType
        }
        userEntityApp {
          linkType
          linkTitle
          linkHint
        }
        layoutType
        iconType {
          iconType
          iconState
          isApprovalActionAvailable
        }
        isApprover
        isRequester
        isObserver
        isLevelBypassingAllowed
        isApproverAddingAllowed
        isPersonalApproverAddingAllowed
        _isRevocable
        isRevoked
        isPending
        isHistory
        approvalBranchId
        branchStatusType {
          approvalState
          statusType
        }
        branchApprovedDate
        branchRejectedDate
        branchDigitalSignature
        approvalTreeId
        treeStatusType {
          statusType
          approvalState
        }
        treeApprovedDate
        treeRejectedDate
        description1
        description2
        description3
        description4
        description5
        digitalSignature
        date1
        amount1
        currency {
          isoCode
        }
        businessUnit {
          name
        }
        department {
          name
        }
        companyCorporatePeriod {
          id
          startDate
          endDate
          _periodYear
        }
        approvalHistoryItemsByDisplayEntityApprovalId(
          orderBy: [
            ITEM_UNIT_1_ASC
            ITEM_DESCRIPTION_1_ASC
            ITEM_DESCRIPTION_2_ASC
          ]
        ) {
          nodes {
            entityItemId
            itemDescription1
            itemDescription2
            itemDescription3
            itemDescription4
            itemDescription5
            itemAmount1
            itemDate1
            invoiceBatchComment {
              comment
              invoice {
                _accountingStampTransactionReference
              }
            }
          }
          aggregates {
            sum {
              itemAmount1
            }
          }
        }
        _isNotesExist
        notesByEntityId (orderBy: _CREATED_DATE_DESC) {
          nodes {
            id
            noteComment
            _createdByUserName
            _createdDate
          }
        }
        _isTagsExist
        entityTagsByEntityId {
          nodes {
            id
            _tagBadgeName
          }
        }
        _isEnvironmentalsExist
        entityEnvironmentalsByEntityId {
          nodes {
            description
            startDate
            endDate
            environmentalMetric {
              id
              environmentalMetric
            }
            entityEnvironmentalItems {
              nodes {
                id
                feet
                gallons
                hours
              }
            }
          }
        }
        _isDocumentsExist
        entityDocumentsByEntityId {
          nodes {
            id
            fileReference
            iconType
            fileIndexInformation
            comment
            documentTypes {
              documentType
            }
          }
        }
        userMessagesByEntityId {
          totalCount
        }
        _isTransactionCancelled
        _isAccountingEntryStampedCompleted
        _accountingStampDate
        _accountingStampUserName
        _accountingStampTransactionReference
      }
    }
  }
}
